{
  "CONTENT_SLUG_INVALID": "El slug solo puede contener letras minúsculas, números y guiones",
  "CONTENT_LINK_NOT_FOUND": "Vínculo no encontrado",
  "PRODUCT_NOT_FOUND": "Producto no encontrado",
  "PRODUCT_ARCHIVED_NOT_FOUND": "Producto archivado no encontrado",
  "PRODUCT_SLUG_TAKEN": "Ya existe un producto con este slug",
  "PRODUCT_STATUS_INVALID": "El estado debe ser DRAFT, PUBLISHED o ARCHIVED",
  "PRODUCT_TARGET_COURSE_NOT_FOUND": "Curso de destino no encontrado",
  "PRODUCT_DELETED": "Producto eliminado correctamente",
  "PRODUCT_DRAFTS_DELETED": "{{count}} curso(s) en borrador eliminado(s) correctamente",
  "PRODUCT_CONVERTED_TO_MODULE": "Curso \"{{title}}\" convertido en módulo con {{count}} clases",
  "PRODUCT_MERGED_TO_COURSE": "{{count}} curso(s) convertido(s) en módulos de \"{{title}}\"",
  "CMS_PAGE_NOT_FOUND": "Página no encontrada",
  "CMS_PAGE_SLUG_TAKEN": "Ya existe una página con este slug",
  "CMS_PAGE_DELETED": "Página eliminada correctamente",
  "CMS_SECTION_NOT_FOUND": "Sección no encontrada",
  "CMS_SECTION_IDENTIFIER_TAKEN": "Ya existe una sección con este identificador en esta página",
  "CMS_SECTION_DELETED": "Sección eliminada correctamente",
  "CMS_BLOCK_NOT_FOUND": "Bloque no encontrado",
  "CMS_BLOCK_DELETED": "Bloque eliminado correctamente",
  "CMS_TEMPLATE_NOT_FOUND": "Plantilla no encontrada",
  "CMS_COMPONENT_NOT_FOUND": "Componente no encontrado",
  "CERTIFICATE_NOT_FOUND": "Certificado no encontrado",
  "CERTIFICATE_REVOKED": "Certificado revocado",
  "CERTIFICATE_TEMPLATE_NOT_FOUND": "Plantilla no encontrada",
  "CERTIFICATE_TEMPLATE_DEFAULT_NOT_DELETABLE": "No se puede eliminar la plantilla predeterminada",
  "CERTIFICATE_TEMPLATE_IN_USE": "Esta plantilla está siendo usada por {{count}} certificado(s)",
  "CERTIFICATE_TEMPLATE_DELETED": "Plantilla eliminada correctamente",
  "CERTIFICATE_PRODUCT_NOT_COMPLETED": "El usuario no ha completado este producto",
  "CERTIFICATE_USER_OR_PRODUCT_NOT_FOUND": "Usuario o producto no encontrado",
  "CERTIFICATE_MEMBER_NOT_FOUND": "Miembro no encontrado",
  "CERTIFICATE_CONTENT_REQUIRED": "Selecciona un contenido para emitir",
  "CERTIFICATE_CONTENT_NOT_FOUND": "Contenido no encontrado",
  "CUSTOMIZATION_PRIMARY_COLOR_INVALID": "El color principal debe ser un código hexadecimal válido",
  "CUSTOMIZATION_SECONDARY_COLOR_INVALID": "El color secundario debe ser un código hexadecimal válido",
  "CUSTOMIZATION_FILE_REQUIRED": "No se ha enviado ningún archivo",
  "CUSTOMIZATION_FILE_TYPE_INVALID": "Formatos aceptados: {{formats}}",
  "CUSTOMIZATION_FILE_TOO_LARGE": "El archivo debe tener como máximo {{max}} MB",
  "PRODUCT_APPEARANCE_COURSE_NOT_FOUND": "Curso no encontrado",
  "PRODUCT_APPEARANCE_SECTION_NOT_FOUND": "Sección no encontrada",
  "PRODUCT_APPEARANCE_SECTION_REMOVED": "Sección eliminada correctamente",
  "PRODUCT_APPEARANCE_SECTIONS_REORDERED": "Secciones reordenadas correctamente",
  "PRODUCT_APPEARANCE_MENU_ITEM_NOT_FOUND": "Elemento del menú no encontrado",
  "PRODUCT_APPEARANCE_MENU_ITEM_REMOVED": "Elemento del menú eliminado correctamente",
  "PRODUCT_APPEARANCE_MENU_REORDERED": "Menú reordenado correctamente",
  "MEMBER_AREA_NOT_FOUND": "Área de miembros no encontrada",
  "MEMBER_AREA_SLUG_TAKEN": "Este slug ya está en uso",
  "MEMBER_AREA_INACTIVE": "Esta área de miembros no está activa",
  "MEMBER_AREA_COLOR_INVALID": "El color debe estar en formato hexadecimal (#RRGGBB)",
  "MEMBER_AREA_DELETED": "Área de miembros eliminada correctamente",
  "MEMBER_AREA_BANNER_NOT_FOUND": "Banner no encontrado",
  "MEMBER_AREA_BANNER_DELETED": "Banner eliminado correctamente",
  "MEMBER_AREA_BANNERS_REORDERED": "Banners reordenados correctamente",
  "MEMBER_AREA_MENU_ITEM_NOT_FOUND": "Elemento del menú no encontrado",
  "MEMBER_AREA_MENU_ITEM_DELETED": "Elemento del menú eliminado correctamente",
  "MEMBER_AREA_MENU_REORDERED": "Menú reordenado correctamente",
  "COURSE_SECTION_NOT_FOUND": "Sección con ID {{id}} no encontrada",
  "COURSE_SECTION_SOME_NOT_FOUND": "Una o más secciones no existen",
  "COURSE_SECTION_PRODUCT_NOT_FOUND": "Producto con ID {{id}} no encontrado",
  "COURSE_SECTION_PRODUCT_ALREADY_ADDED": "El producto ya está en esta sección",
  "COURSE_SECTION_PRODUCT_NOT_IN_SECTION": "El producto no está en esta sección",
  "COURSE_SECTION_PRODUCTS_NOT_IN_SECTION": "Uno o más productos no están en esta sección",
  "CATEGORY_NOT_FOUND": "Categoría no encontrada",
  "CATEGORY_SLUG_TAKEN": "El slug ya existe",
  "CATEGORY_DELETED": "Categoría eliminada",
  "LEARNING_TRAIL_NOT_FOUND": "Ruta no encontrada",
  "LEARNING_TRAIL_PRODUCTS_NOT_FOUND": "No se encontraron uno o más productos",
  "LEARNING_TRAIL_UNAVAILABLE": "Esta ruta no está disponible",
  "LEARNING_TRAIL_ALREADY_ENROLLED": "El usuario ya está inscrito en esta ruta",
  "LEARNING_TRAIL_ENROLLMENT_NOT_FOUND": "Inscripción en la ruta no encontrada",
  "MODULE_NOT_FOUND": "Módulo no encontrado",
  "MODULE_PARENT_NOT_FOUND": "Módulo padre no encontrado",
  "MODULE_ALREADY_LINKED": "El módulo ya está vinculado a este curso",
  "MODULE_SECTION_DELETED": "Sección eliminada. Los submódulos se han desvinculado.",
  "MODULE_CHILDREN_REORDERED": "Submódulos reordenados",
  "MODULE_UNLINKED": "Módulo desvinculado del curso",
  "LESSON_NOT_FOUND": "Clase no encontrada",
  "LESSON_ACCESS_DENIED": "No tienes acceso a esta clase",
  "LESSON_ALREADY_LINKED": "La clase ya está vinculada a este módulo",
  "LESSON_DELETED": "Clase eliminada",
  "LESSON_UNLINKED": "Clase desvinculada del módulo",
  "ANALYTICS_EXPORT_TYPE_INVALID": "Tipo de exportación no válido",
  "PRODUCT_ACCESS_DENIED": "No tienes acceso a este curso",
  "PRODUCT_VISIBILITY_INVALID": "La visibilidad debe ser HIDDEN o LOCKED",
  "CUSTOMIZATION_THEME_INVALID": "El modo de tema debe ser STUDENT_CHOICE, LIGHT o DARK",
  "LESSON_VIDEO_PROVIDER_INVALID": "El proveedor de video debe ser gumlet, youtube, vimeo, panda o direct",
  "LESSON_VIDEO_URL_INVALID": "Enlace de video no válido para el proveedor elegido",
  "LESSON_COMPLETION_TRACKED_BY_PLAYER": "Esta clase se completa automáticamente cuando ves el video"
}
